import type { TableDataRow } from "@/types/charts";

export type TableFilterRule = (row: TableDataRow, selectedHeaders: string[]) => boolean;

export function applyTableFilters(
  data: TableDataRow[],
  selectedHeaders: string[],
  rules: TableFilterRule[] = []
): TableDataRow[] {
  if (!rules.length) return data;
  return data.filter((row) => rules.every((rule) => rule(row, selectedHeaders)));
}

export function excludeNullFieldUnderConditions(config: {
  targetField: string;
  mustInclude?: string[];
  mustNotInclude?: string[];
}): TableFilterRule {
  return (row, selectedHeaders) => {
    const { targetField, mustInclude = [], mustNotInclude = [] } = config;

    const includesRequired = mustInclude.every((field) => selectedHeaders.includes(field));
    const excludesForbidden = mustNotInclude.every((field) => !selectedHeaders.includes(field));
    const fieldIsNull = row[targetField] == null;

    if (includesRequired && excludesForbidden && fieldIsNull) {
      return false;
    }
    return true;
  };
}
